import { Component } from "@angular/core";
import { ScriptService } from "./services/script.service";
import { Product } from "./models/product";
import { ProductService } from "./services/product.service";
import { ActivatedRoute, Router } from "@angular/router";
// for cart
import { UNITS, Price } from "./models/price";
import { Item } from "./models/item";
import { Quantity } from "./models/quantity";
import { CartService } from "./services/cart.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "angular-universal-heroku";

  products: Product[] = new Array();
  id: string;
  searchString = "";
  // for cart
  keyUp = "";
  quant: number = 1;
  chosenUnit: string = UNITS[0].name;

  private pathToAssets: string = "../../assets/";

  constructor(
    private scriptService: ScriptService,
    private productService: ProductService,
    private route: ActivatedRoute,
    private cartService: CartService,
    private router: Router
  ) {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.products = productService.search(this.id);
    });
  }

  ngOnInit() {
    this.scriptService
      .load("main")
      .then((data) => {
        console.log("script loaded ", data);
      })
      .catch((error) => console.log(error));
  }

  addToCart(product) {
    this.chosenUnit = product.prices[0].unit;
    if (this.keyUp) this.quant = parseFloat(this.keyUp);
    if (this.chosenUnit && Number.isFinite(this.quant) && !(this.quant <= 0)) {
      let item: Item = new Item();
      let quant: Quantity = new Quantity();
      quant.quantity = this.quant;
      quant.unit = this.chosenUnit;
      item.product = product;
      item.quantity = quant;
      this.cartService.add(item);
    } else {
      this.quant = 1;
      Swal({
        title: "Bad Quantity",
        text: "Please enter a non zero quantity value to proceed",
        type: "warning",
        confirmButtonText: "Ok got it!",
        confirmButtonColor: "#07a763",
      });
    }
  }

  search() {
    if (this.searchString !== "") {
      this.router.navigate(["search/" + this.searchString.replace(" ", "+")]);
    }
  }
}
